// Imports
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tippy from '@tippyjs/react';
import { darken } from 'polished';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import LinkButton from '../../../../../shareables/foundation/front-end/components/buttons/link';
import LoadingRow from '../../../../../shareables/foundation/front-end/components/tables/loading-row';
import { useAppDispatch } from '../../../../../shareables/foundation/front-end/redux/hooks';
import tippyProps from '../../../../../shareables/foundation/front-end/utils/tippy-props';
import apiActions from '../../../../../shareables/integrations/api/redux/actions';
import { GetSurveysResponse } from '../../../../../shareables/types/api/main/website/surveys/get';
import { GeneratedThemeProps } from '../../../../templates/template-style';
import Table from '../page-types/shared-components/table';
import EmptyStateRow from '../page-types/shared-components/table/empty-state-row';
import PageTitle from '../shared-components/page-title';


// Styled components
const SurveyNameCell = styled.td`
	&&& {
		overflow-wrap: anywhere;
	}
`;

const TakeSurveyButton = styled(LinkButton)<{ theme: GeneratedThemeProps }>`
	background-color: ${(props) => props.theme.baseColor};
	
	&:hover,
	&:focus {
		background-color: ${(props) => darken(0.05, props.theme.baseColor)} !important;
	}
`;


// Define the accepted props
interface Props {
	storybookSurveys?: GetSurveysResponse;
}


// Function component
const Surveys: React.FC<Props> = ({ storybookSurveys }) => {
	// Use state
	const [surveys, setSurveys] = useState<GetSurveysResponse | null>(storybookSurveys ?? null);
	
	
	// Use Redux functionality
	const dispatch = useAppDispatch();
	
	
	// Load surveys on mount
	useEffect(() => {
		void dispatch(
			apiActions.call<undefined, undefined, GetSurveysResponse>({
				action: 'GET',
				uri: `/website/${window.location.hostname}/surveys`,
				completion: (json) => {
					setSurveys(json.response);
				},
			})
		);
	}, [dispatch]);
	
	
	// Return JSX
	return (
		<React.Fragment>
			<PageTitle>Surveys</PageTitle>
			
			<Table>
				<thead>
					<tr>
						<th>Survey name</th>
						<th>Take</th>
					</tr>
				</thead>
				<tbody>
					{surveys?.length === 0 && <EmptyStateRow>No surveys at this time…</EmptyStateRow>}
					
					{surveys?.map((survey) => (
						<tr key={survey.id}>
							<SurveyNameCell className='allow-wrapping'>{survey.name}</SurveyNameCell>
							<td>
								<Tippy {...tippyProps} content='Take this survey'>
									<TakeSurveyButton to={`/surveys/take?id=${survey.id}`} aria-label='Take survey' smaller>
										<FontAwesomeIcon icon={faChevronRight} />
									</TakeSurveyButton>
								</Tippy>
							</td>
						</tr>
					))}
					
					{surveys === null && <LoadingRow />}
				</tbody>
			</Table>
		</React.Fragment>
	);
};

export default Surveys;
